'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/auth';
import { QUERY_STATUS } from '@/types/async-protocol';

export function useProtectedRoute(redirectTo: string = '/') {
  const auth = useAuth();
  const user = auth.data?.user ?? null;
  const loading = auth.status === QUERY_STATUS.Loading;
  const router = useRouter();

  useEffect(() => {
    if (!loading && !user) {
      router.replace(redirectTo);
    }
  }, [loading, user, redirectTo, router]);

  return { user, loading };
}

